import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import React from "react";
import PropTypes from "prop-types";
import MATCHES from "./matches.js";
var _media = /*#__PURE__*/new _WeakMap();
class Media extends React.Component {
  constructor() {
    super(...arguments);
    _classPrivateFieldInitSpec(this, _media, {
      writable: true,
      value: null
    });
    _defineProperty(this, "state", {
      matches: MATCHES.NOT_SURE
    });
    _defineProperty(this, "handleMediaChange", mediaEvent => {
      this.setState({
        matches: mediaEvent.matches ? MATCHES.YES : MATCHES.NO
      });
    });
  }
  componentDidMount() {
    _classPrivateFieldSet(this, _media, _globalThis.matchMedia(this.props.query));
    this.handleMediaChange(_classPrivateFieldGet(this, _media));
    _classPrivateFieldGet(this, _media).addListener(this.handleMediaChange);
  }
  componentWillUnmount() {
    _classPrivateFieldGet(this, _media).removeListener(this.handleMediaChange);
  }
  render() {
    return this.props.children(this.state.matches);
  }
}
process.env.NODE_ENV !== "production" ? Media.propTypes = {
  /**
   * Media query to match against. Example `(max-width: 800px)`
   */
  query: PropTypes.string.isRequired,
  /**
   * Function which will receive the match state. this should be compared against a value in the `MATCHES` constant
   */
  children: PropTypes.func.isRequired
} : void 0;
export default Media;